export default function inactivationPriority(inactivationReasons) {
  const reasons = inactivationReasons?.length > 0 ? inactivationReasons?.map(el => el.reason) : []
  if (reasons.includes('Blocked by admin')) return 'Blocked by admin'
  if (reasons.includes('Admin')) return 'Admin'
  if (reasons.includes('Billing')) return 'Billing'
  if (reasons.includes('Documents')) return 'Documents'
  return 'Not provided'
}
